@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.login

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.passengers.PassengerDto


object GetPassengerProfileDetailsEndpoint : EndPoint<GetPassengerProfileDetailsEndpoint.Request, GetPassengerProfileDetailsEndpoint.Response>() {
    class Request

    class Response(
        val passenger: PassengerDto
    )
}